import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { UseCase } from 'src/base/use-case'
import { ClientRepository } from 'src/domain/repositories/client.repository'

@Injectable()
export class GetUserUseCase implements UseCase<void, any> {
	constructor(private clientRepository: ClientRepository) {}

	execute(): Observable<any> {
		return this.clientRepository.GetUser()
	}
}
